import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";
import cmsClient from "src/services/cmsClient";

interface MoveFavouriteFeedOptions {
	uuid: string;
	offset: number;
}

const moveFavouriteFeed = async ({
	uuid,
	offset
}: MoveFavouriteFeedOptions) => {
	const url = `/homepage/admin/favourite-feeds/${uuid}/move/`;
	const response = await cmsClient.put<unknown>(url, { offset });

	return response.data;
};

const useMoveFavouriteFeed = () => {
	const queryClient = useQueryClient();

	const onSuccess = () => {
		queryClient.invalidateQueries(["favourite-feeds"]);
	};

	const onError = () => {
		toast.error(
			<CustomToast type="Error" message="Something went wrong reordering" />,
			{ hideProgressBar: true }
		);
	};

	const mutation = useMutation(moveFavouriteFeed, {
		onError,
		onSuccess
	});

	return mutation;
};

export default useMoveFavouriteFeed;
